import { render, staticRenderFns } from "./blindBox.vue?vue&type=template&id=6cca4f16&scoped=true&"
import script from "./blindBox.vue?vue&type=script&lang=js&"
export * from "./blindBox.vue?vue&type=script&lang=js&"
import style0 from "./blindBox.vue?vue&type=style&index=0&id=6cca4f16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca4f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cca4f16')) {
      api.createRecord('6cca4f16', component.options)
    } else {
      api.reload('6cca4f16', component.options)
    }
    module.hot.accept("./blindBox.vue?vue&type=template&id=6cca4f16&scoped=true&", function () {
      api.rerender('6cca4f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/blindBox.vue"
export default component.exports